export default "__VITE_ASSET__ef331475__"